import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Building2, Shield, Coffee, Heart, GraduationCap, HardHat } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Building2: Building2,
  Shield: Shield,
  Coffee: Coffee,
  Heart: Heart,
  GraduationCap: GraduationCap,
  HardHat: HardHat
};

const IndustriesSection = () => {
  const { industries } = mockData;

  return (
    <section id="industries" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Trusted uniform partner across diverse sectors in Kuwait
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry) => {
            const IconComponent = iconMap[industry.icon];
            return (
              <Card
                key={industry.id}
                className="border-2 border-gray-100 hover:border-blue-900 hover:shadow-xl transition-all duration-300 bg-white group cursor-pointer"
              >
                <CardHeader className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-900 transition-colors duration-300">
                    <IconComponent className="h-8 w-8 text-blue-900 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900">
                    {industry.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <CardDescription className="text-gray-600 text-base">
                    {industry.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
